import React, { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";
import VerifyCodePage from "./VerifyCodePage";
import HomePage from "./HomePage";
import PhotosPage from "./PhotosPage";
import AccountPage from "./AccountPage";
import NavMenu from "./NavMenu";


function App() {
  const [registerEmail, setRegisterEmail] = useState("");

  return (
    <Router>
      <div className="App" style={{ paddingTop: 48 }}>
        <NavMenu />
        <Routes>
          <Route path="/" element={<LoginPage onShowRegister={email => { setRegisterEmail(email); window.location.href = "/#/register"; }} />} />
          <Route path="/register" element={<RegisterPage initialEmail={registerEmail} />} />
          <Route path="/verify" element={<VerifyCodePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/photos" element={<PhotosPage />} />
          <Route path="/account" element={<AccountPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
